import authenticationResolvers from "./authenticationResolvers";

const resolvers = {
  ...authenticationResolvers
};

export default resolvers;
